import React from 'react';
import { Box, Container, HStack, Text, Flex, Icon, Menu, MenuButton, MenuList, MenuItem, Avatar, Button } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { FaCloud } from 'react-icons/fa';
import { removeToken, getUser } from '../utils/auth';
import { useNavigate } from 'react-router-dom';
import MonitoringDashboard from '../components/MonitoringDashboard';

export default function MonitoringPage() {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    removeToken();
    navigate('/login');
  };

  return (
    <Box minH="100vh" bgGradient="linear(to-br, #0a0e27, #1a1f3a, #2d1b4e)">
      <Box bg="transparent" px={6} py={0} h="64px">
        <Flex justify="space-between" align="center" h="100%">
          <HStack spacing={8}>
            <HStack spacing={2}>
              <Icon as={FaCloud} color="white" boxSize={5} />
              <Text color="white" fontSize="18px" fontWeight="bold">Automate Your Workflow</Text>
            </HStack>
            <HStack spacing={6}>
              <Text color="rgba(255,255,255,0.65)" fontSize="14px" cursor="pointer" onClick={() => navigate('/home')}>Home</Text>
              <Text color="rgba(255,255,255,0.65)" fontSize="14px" cursor="pointer" onClick={() => navigate('/pipeline')}>Pipeline</Text>
              <Text color="white" fontSize="14px" cursor="pointer" fontWeight="semibold" onClick={() => navigate('/monitoring')}>Monitoring</Text>
              <Text color="rgba(255,255,255,0.65)" fontSize="14px" cursor="pointer" onClick={() => navigate('/iac')}>IAC</Text>
            </HStack>
          </HStack>
          <Menu>
            <MenuButton as={Button} variant="ghost" color="white">
              <HStack spacing={2}>
                <Avatar size="sm" name={user?.email || 'User'} />
                <Text fontSize="14px">{user?.sub || 'user@example.com'}</Text>
                <ChevronDownIcon />
              </HStack>
            </MenuButton>
            <MenuList>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </Box>
      <Container maxW="container.xl" py={8}>
        <MonitoringDashboard />
      </Container>
    </Box>
  );
}
